<ada-container
	verticalSpacing="medium"
	[padding]="ui.Spacing.SPACING_LARGE"
>
	<!-- General Info -->
	<ada-card>
		<ada-text
			data-container-selector="ada-card-header"
			content="General Information"
		></ada-text>
		<ada-container
			data-container-selector="ada-card-body"
			horizontalSpacing="medium"
			verticalSpacing="small"
			[colCount]="4"
		>
			<!-- Description -->
			<ada-text
				fontWeight="bold"
				content="Description"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.description"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>

			<!-- Publication Time -->
			<ada-text
				fontWeight="bold"
				content="Last Publication Time"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.lastPublishedTime | adaLocalizedDate: 'short'"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>

			<!-- Modification Time -->
			<ada-text
				fontWeight="bold"
				content="Last Modification Time"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.lastModifiedTime | adaLocalizedDate: 'short'"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>

			<!-- Vulnerability Status -->
			<ada-text
				fontWeight="bold"
				content="NVD Status"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.vulnerabilityStatus"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>
		</ada-container>
	</ada-card>

	<!-- Scores -->
	<ada-card>
		<ada-text
			data-container-selector="ada-card-header"
			content="CVSS Scores"
		></ada-text>
		<ada-container
			data-container-selector="ada-card-body"
			horizontalSpacing="medium"
			verticalSpacing="small"
			[colCount]="4"
		>
			<!-- CVSS V2 Score -->
			<ada-text
				fontWeight="bold"
				content="CVSS V2 Score"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.cvssV2Score || '--'"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>

			<!-- CVSS V30 Score -->
			<ada-text
				fontWeight="bold"
				content="CVSS V30 Score"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.cvssV30Score || '--'"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>

			<!-- CVSS V31 Score -->
			<ada-text
				fontWeight="bold"
				content="CVSS V31 Score"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-text>
			<ada-text
				[content]="context.cvssV31Score || '--'"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			></ada-text>
		</ada-container>
	</ada-card>

	<!-- Cpe -->
	<ada-card>
		<ada-text
			data-container-selector="ada-card-header"
			content="Affected CPEs"
		></ada-text>
		<ada-cpe-web-view-table
			data-container-selector="ada-card-body"
			[cpeWebViews]="context.cpes"
		></ada-cpe-web-view-table>
	</ada-card>
</ada-container>
